import Cookies from 'js-cookie';

export default function useCookiesHelper() {
  const addCookie = (key, value, options = {}) => {
    Cookies.set(key, value, {
      secure: true,
      sameSite: 'Strict',
      ...options
    });
  };

  const getCookie = (key) => {
    return Cookies.get(key);
  };

  const removeCookie = (key, options = {}) => {
    Cookies.remove(key, options);
  };

  return {
    addCookie,
    getCookie,
    removeCookie
  };
}
